import { COMMON_DRAFT_ARCHIVARIUS } from '@alfa-bank/site-envconfig';
import { httpClient } from '@alfa-bank/site-http-client';
import type { TOptions } from '@alfa-bank/site-http-client/src/models';

import type { IDraftFirstStepData, IDraftFirstStepResponse } from './models';

const REQUEST_OPTIONS: Readonly<TOptions> = {
    headers: {
        'Content-Type': 'application/json',
    },
    credentials: 'include',
};

const getDraftApi = () =>
    httpClient.get<IDraftFirstStepResponse>(COMMON_DRAFT_ARCHIVARIUS(), null, REQUEST_OPTIONS);

const putDraftApi = ({ data }: IDraftFirstStepData) =>
    httpClient.put<IDraftFirstStepResponse>(COMMON_DRAFT_ARCHIVARIUS(), data, REQUEST_OPTIONS);

const deleteDraftApi = () =>
    httpClient.delete<IDraftFirstStepResponse>(COMMON_DRAFT_ARCHIVARIUS(), null, REQUEST_OPTIONS);

export const draftFirstStepApi = {
    get: getDraftApi,
    put: putDraftApi,
    delete: deleteDraftApi,
};
